import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetStatus } from '../../../../state';

const WarrantyExpirationEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetStatus({ warrantyExpiration: event.target.value }));
  };

  return (
    <TextField
      label="Warranty Expiration"
      size="small"
      type="date"
      fullWidth
      InputLabelProps={{ shrink: true }}
      value={currentAsset?.warrantyExpiration ? currentAsset.warrantyExpiration.substring(0, 10) : ''}
      onChange={handleChange}
    />
  );
};

export default WarrantyExpirationEdit;
